module.exports = __webpack_public_path__ + "img/rs.291d0fb6.svg";